import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetDataQuality } from '../AppActionTypes';

export interface SetDataQualityAction extends Action {
  item: IContentInfo;
}

export function setDataQualityAction(item: IContentInfo): SetDataQualityAction {
  return {
    type: SetDataQuality,
    item
  };
}
